module.exports = __webpack_public_path__ + "static/media/01B.ff3a6fa2.png";